// =============================================================
// SINGLE SOURCE OF TRUTH for which network the dApp runs on.
//
// Change ACTIVE_NETWORK to flip between environments. This is the
// ONLY place you choose the chain. It is never shown to the user.
//
//   "opbnbMainnet"  -> production
//   "opbnbTest"     -> internal testing
// =============================================================

import { NETWORKS } from "./networks";
import { CONTRACTS } from "./contracts";

// 🔧 CHOOSE THE NETWORK HERE (in code only):
export const ACTIVE_NETWORK_KEY = "opbnbMainnet";

export const ACTIVE_NETWORK = NETWORKS[ACTIVE_NETWORK_KEY];
export const ACTIVE_CONTRACTS = CONTRACTS[ACTIVE_NETWORK_KEY];

// Deployment block of the purchase contract (for the activity/event scan).
// 0 means "not set" -> the activity feed falls back to a recent block window.
export const ACTIVE_DEPLOY_BLOCK = ACTIVE_CONTRACTS.deployBlock || 0;

// USDT on opBNB uses 18 decimals (matches the SCN contract assumptions).
export const USDT_DECIMALS = 18;
export const SCN_DECIMALS = 18;

// Default referrer id used by the contract when none/invalid is supplied.
export const DEFAULT_REFERRER = 100000;

// How often (ms) the dashboard re-reads on-chain data. Polling, not callbacks.
export const POLL_INTERVAL_MS = 15000;

// UI brand text
export const APP_NAME = "SC Fractional Node";

// External DEX (swap) URL — opened from the bottom-nav "Swap" item.
export const DEX_URL = "https://dex.smartcore.live/";
